/**
 * Public marketing demos (login page) — staging/non-prod only.
 * Production builds must not surface pitch/pricing packs on /login.
 */

/**
 * @param {{ reactAppEnv?: string, nodeEnv?: string }} [params]
 * @returns {boolean}
 */
export function isMarketingDemosPublicEnabled(params = {}) {
  const appEnv = String(params.reactAppEnv ?? process.env.REACT_APP_ENV ?? '').toLowerCase();
  const nodeEnv = String(params.nodeEnv ?? process.env.NODE_ENV ?? '').toLowerCase();
  const signal = `${appEnv} ${nodeEnv}`;

  if (appEnv === 'prod' || appEnv === 'production') {
    return false;
  }
  // Avoid treating "staging" as production when the string contains "prod" elsewhere.
  if (signal.includes('prod') && !signal.includes('stag') && !signal.includes('dev')) {
    return false;
  }
  return true;
}
